import axios from 'axios';
import { BRAND_COLORS } from './types';

export const getBrandColors = () => async (dispatch) => {
	const chekkitDefault = '#111827';

	try {
		// if on main chekkit domain, no need to fetch.
		if (
			window.location.hostname.includes('chekkit') ||
			window.location.hostname.includes('localhost')
		) {
			// Check if we're in dark mode to return appropriate color
			const isDarkMode =
				document.documentElement.classList.contains('dark');

			// Return different colors based on theme
			const primaryColor = isDarkMode ? '#e5e5e5' : '#111827';

			dispatch({ type: BRAND_COLORS, payload: primaryColor });

			return { primaryColor };
		}

		// all other domains, we fetch the reseller brand color based off the hostname
		const res = await axios.get('/api/brand-colors');

		const { primaryColor } = res.data;

		dispatch({ type: BRAND_COLORS, payload: primaryColor });
		return { primaryColor };
	} catch {
		dispatch({
			type: BRAND_COLORS,
			payload: { primaryColor: chekkitDefault },
		});
		return { primaryColor: chekkitDefault };
	}
};
